
import Vue from 'vue';
import { faTimes, faBars } from '@delfi.lt/fa-kit/icons/modules/classic/solid';

export default Vue.extend({
  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      faTimes,
      faBars,
    };
  },
});
